import {
  useCompleteAuditEntryMutation,
  useCreateAuditEntryMutation,
} from 'src/graphql';

export const useAuditEntry = () => {
  const { mutate: createAuditEntry } = useCreateAuditEntryMutation();
  const { mutate: completeAuditEntry } = useCompleteAuditEntryMutation();

  return { createAuditEntry, completeAuditEntry };
};
